import { useEffect, useRef } from 'react';
import MessageBubble from './MessageBubble';
import ClarificationOptions from './ClarificationOptions';

const MessageList = ({ messages, onSelectOption, isBusy }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [messages]);

  return (
    <div ref={containerRef} className="flex flex-col gap-4 overflow-y-auto pr-1 flex-1 min-h-0">
      {messages.map((msg) => (
        <div key={msg.id} className="space-y-2">
          <MessageBubble role={msg.role} content={msg.content} />
          {msg.type === 'clarification' && msg.options ? (
            <ClarificationOptions options={msg.options} onSelect={onSelectOption} disabled={isBusy} />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default MessageList;
